const getImageSrc = (value) => {
  if (typeof value === 'string') return value;
  return value?.url || value?.source || value?.path || '';
};

export const buildProductMediaImages = (cloudinaryAssets = [], productName = '', sku = '') => {
  const mediaEntries = cloudinaryAssets.map((asset, index) => ({
    imageSrc: `https://res.garmin.com/transform/${asset.mediaType}/upload/b_rgb:FFFFFF,c_pad,dpr_1.0,f_auto,h_1200,q_auto,w_1200/c_pad,h_1200,w_1200/${asset.publicId}`,
    thumbnailSrc: `https://res.garmin.com/transform/${asset.mediaType}/upload/b_rgb:FFFFFF,c_pad,dpr_1.0,f_auto,h_100,q_auto,w_100/c_pad,h_100,w_100/${asset.publicId}`,
    altText: `${productName} - ${index}`,
  }));

  return {
    images: mediaEntries.map((entry) => ({
      imageSrc: entry.imageSrc,
      altText: entry.altText,
    })),
    thumbnails: mediaEntries.map((entry) => ({
      imageSrc: entry.thumbnailSrc,
      altText: entry.altText,
    })),
    productSku: sku,
  };
};

export const buildCustomerMediaImages = (customerImages = [], productName = '') => {
  const mediaEntries = customerImages
    .map((entry, index) => {
      const imageSrc = getImageSrc(entry?.images?.original) || getImageSrc(entry?.images?.normal);
      const thumbnailSrc = getImageSrc(entry?.images?.thumbnail) || imageSrc;
      if (!imageSrc) return null;

      const username = entry?.username || 'customer';
      return {
        imageSrc,
        thumbnailSrc,
        altText: `${productName} - customer image by ${username} - ${index}`,
        username,
      };
    })
    .filter(Boolean);

  return {
    images: mediaEntries.map((entry) => ({
      imageSrc: entry.imageSrc,
      altText: entry.altText,
      username: entry.username,
    })),
    thumbnails: mediaEntries.map((entry) => ({
      imageSrc: entry.thumbnailSrc,
      altText: entry.altText,
      username: entry.username,
    })),
  };
};

export const buildProductVideos = (videosURLs) => {
  if (typeof videosURLs === 'string') {
    return videosURLs
      .split(',')
      .map((url) => url.trim())
      .filter(Boolean);
  }

  return [];
};
